export const formatStoryblokSlug = (slug: string): string => {
  return `/${slug.replace(/^\/?en\//, '')}`;
};

export const slugToLabel = (slug: string): string => {
  return slug
    .split('-')
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join(' ');
};

export const labelToSlug = (label: string): string => {
  return label
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
};
